import getSubscriptionDescription from '../../../utils/getSubscriptionDescription'
import { Button } from '../../uiLib'

const SelectedSubscriptionDetails = ({ subscription, addToCart, loading, cartItems, t }) => {
  const subscriptionDescription = subscription && getSubscriptionDescription(subscription.id, t)
  const isButtonDisabled = cartItems.filter(item => item.id === subscription.id).length > 0
  return (
    <div>
      { subscription ? (
        <blockquote className="cart-description">
          <div className="cart-title m-b-md">{ subscriptionDescription.title }</div>
          <p>{ subscriptionDescription.description }</p>
          <Button
            outlined
            btType="primary"
            loading={loading}
            onClick={() => addToCart(subscription.id)}
            disabled={isButtonDisabled}>
            { isButtonDisabled ? t('common:already-in-cart') : t('common:add-to-cart') }
          </Button>
        </blockquote>
      )  : null  }
    </div>
  )
}

export default SelectedSubscriptionDetails



// WEBPACK FOOTER //
// ./components/SubscriptionsSelector/SelectedSubscriptionDetails/index.js